import {
	Card,
	Col,
	Pagination,
	Row,
	Table,
	Checkbox,
	Select,
	Input,
	Button,
	Tooltip,
	Dropdown,
} from 'antd'
import moment from 'moment'
import profileService from 'src/services/profile.service'
import { useContext, useEffect, useState, useRef } from 'react'
import * as api from 'src/configs/API'
import { GlobalContext } from 'src/pages/_app'
import { useRouter } from 'next/router'
import request from 'src/utils/request'
import {
	PaperIcon,
} from 'src/components/CustomIcon'
import openNotificationWithIcon from 'src/components/Notification'
// import { useDebounce } from '@react-hook/debounce'
import { DownOutlined } from '@ant-design/icons'
import DropdownFilter from 'src/components/DropdownFilter'
import NotifyPopup from 'src/components/NotifyPopup'
import FeeStatusTag from 'src/components/FeePartials/FeeStatusTag'
import DateFilterBlockV3 from 'src/components/FeePartials/DateFilterBlockV3'
import { useDebounce } from 'src/hooks/useDebounce'
import CustomTag from 'src/components/CustomTag'
import { ExportImage } from 'src/components/CustomerModal'

const { Option } = Select
const TIME_ACCEPT_DAYS = 31
function TableImageConfirm({ onFilter, filter, hasSelect, status, onSearch }) {
	const calendarRef = useRef()
	const router = useRouter()

	//Search
	const [searchOrderCode, setSearchOrderCode] = useState('')
	const [searchExternalCode, setSearchExternalCode] = useState('')
	const orderCode = useDebounce(searchOrderCode, 700)
	const externalCode = useDebounce(searchExternalCode, 700)
	//
	const [dataSource, setDataSource] = useState([])
	const [listOrderCode, setListOrderCode] = useState('')
	const [pageSize, setPageSize] = useState(10)
	const [pageIndex, setPageIndex] = useState(1)
	const [statusID, setStatusID] = useState('')
	const [total, setTotal] = useState(0)
	const [type, setType] = useState(false)
	const [loading, setLoading] = useState(false)
	const [isOpenRange, setIsOpenRange] = useState(false)
	const [isVisiblePopup, setIsVisiblePopup] = useState(false)
	const [imageNoti, setImageNoti] = useState('')
	const [messageNoti, setmessageNoti] = useState('')
	const [timeRange, setTimeRange] = useState({
		startDate: moment().startOf('month'),
		endDate: new Date(),
	})
	const [store, setStore] = useState([])
	const [clientHubID, setClientHubID] = useState(0)
	const [isReset, setIsReset] = useState(false)
	const [isValidTime, setIsValidTime] = useState(false)
	const [openAmount, setOpenAmount] = useState(false)
	const [openDR, setOpenDR] = useState(false)
	const [loadingExport, setLoadingExport] = useState(false)

	const [visibleExportImage, setVisibleExportImage] = useState(false)

	const openModalExportImage = () => {
		setVisibleExportImage(true)
	}
	const closeModalExportImage = () => {
		setVisibleExportImage(false)
	}
	const columns = [
		{
			title: 'Mã đơn hàng 247Express',
			key: 'orderCode',
			dataIndex: 'orderCode',
		},
		{
			title: 'Mã đơn hàng KH',
			key: 'externalCode',
			dataIndex: 'externalCode',
		},
		{
			title: 'Trạng thái',
			key: 'statusName',
			dataIndex: 'statusName',
			render: (text) => {
				return <CustomTag text={text} />
			},
		},
		{
			title: 'Loại vận đơn',
			align: 'center',
			dataIndex: 'isReturnOrder',

			render: (value, record) =>
				record.isReturnOrder ? (
					<FeeStatusTag text={'Vận đơn trả phát một phần'} color={'#003B4C'} />
				) : (
					<FeeStatusTag text={' '} color={'#ffffff'} />
				),
		},
		{
			title: 'Chi tiết',
			width: '10%',
			render: (text, record) => {
				return (
					<span
						style={{
							display: 'flex',
							justifyContent: 'left',
						}}
					>
						<Tooltip title="Chi tiết">
							<PaperIcon
								className="icon-active"
								onClick={() => {
									router.push({
										pathname: `/tra-cuu-van-don/${record.orderCode}`,
									})
								}}
							/>
						</Tooltip>
					</span>
				)
			},
		},
	]
	const { user } = useContext(GlobalContext)

	const handleDownloadImages = (key) => {
		setLoadingExport(true)

		switch (key) {
			case 1:
				if (listOrderCode.length) {
					request
						.pmsApi({
							url: api.PMS_APIs.API_DOWNLOAD_IMAGES + '?OrderCodes=' + listOrderCode.toString(),
							method: 'GET',
							responseType: 'blob',
						})
						.then((res) => {
							if (!res.isError) {
								const url = window.URL.createObjectURL(res)
								const a = document.createElement('a')
								a.href = url
								a.download = 'download.zip'
								document.body.appendChild(a)
								a.click()
								window.URL.revokeObjectURL(url)
								setmessageNoti('Tải ảnh thành công')
								setImageNoti('/images/success_noti.png')
								setIsVisiblePopup(true)
								getListData()
							}
						})
						.catch((err) => {
							setmessageNoti('Tải ảnh không thành công')
							setImageNoti('/images/fail-noti.png')
							setIsVisiblePopup(true)
						})
						.finally(() => {
							closeModalExportImage()
							setLoadingExport(false)
						})
				} else {
					setLoadingExport(false)
					openNotificationWithIcon(
						'warning',
						'Hệ thống',
						' Vui lòng chọn ảnh xác nhận phát cần export'
					)
				}
				break
			case 2:
				let data = {
					FromDate: moment(timeRange.startDate).format('YYYY-MM-DD'),
					ToDate: moment(timeRange.endDate).format('YYYY-MM-DD'),
					Status: statusID,
					OrderCode: !!orderCode ? orderCode : '',
					ExternalCode: !!externalCode ? externalCode : '',
					PageIndex: pageIndex - 1,
					PageSize: pageSize,
					ClientID: user?.clientID,
					ClientHubID: clientHubID,
					IsOneDelivery: type,
				}

				request
					.pmsApi({
						url: api.PMS_APIs.API_CHECK_EXPORT_IMAGE,
						data,
						method: 'POST',
					})
					.then((res) => {
						if (res.isEmpty || res.isSendMail || res.isError) {
							setLoadingExport(false)

							openNotificationWithIcon('error', 'Hệ thống', res.errorMessage)
							return
						} else {
							request
								.pmsApi({
									url: api.PMS_APIs.API_GET_IMAGE_BY_CONDITIONS,
									data,
									method: 'POST',
									responseType: 'blob',
								})
								.then((response) => {
									setImageNoti('/images/success_noti.png')
									setmessageNoti('Đã export thành công các đơn hàng được chọn!')
									setIsVisiblePopup(true)
									// setTimeout(() => {
									// 	setIsVisiblePopup(false)
									// }, 2500)
									const url = window.URL.createObjectURL(response)
									const a = document.createElement('a')
									a.href = url
									a.download = `FileAnh.zip`
									document.body.appendChild(a)
									a.click()
									window.URL.revokeObjectURL(url)
								})
								.catch((e) => {
									setmessageNoti('Export không thành công.')
									setImageNoti('/images/fail-noti.png')
									setIsVisiblePopup(true)
									setTimeout(() => {
										setIsVisiblePopup(false)
									}, 2500)
								})
								.finally(() => {
									closeModalExportImage()
									setLoadingExport(false)
								})
						}
					})
					.finally(() => {
						setLoadingExport(false)
					})

				break
			default:
				break
		}
	}
	const handleTimeRangeChange = (data) => {
		if (data.fromDate)
			setTimeRange({
				...timeRange,
				startDate: data.fromDate,
			})
		if (data.toDate)
			setTimeRange({
				...timeRange,
				endDate: data.toDate,
			})
	}
	const getListData = () => {
		setLoading(true)
		request.pmsApi
			.post(api.PMS_APIs.API_GET_IMAGE_URLS, {
				FromDate: moment(timeRange.startDate).format('YYYY-MM-DD'),
				ToDate: moment(timeRange.endDate).format('YYYY-MM-DD'),
				Status: statusID,
				OrderCode: !!orderCode ? orderCode : '',
				ExternalCode: !!externalCode ? externalCode : '',
				PageIndex: pageIndex - 1,
				PageSize: pageSize,
				ClientID: user?.clientID,
				ClientHubID: clientHubID,
				IsOneDelivery: type,
			})
			.then((res) => {
				if (!res.isError) {
					setDataSource(res.items)
					setTotal(res.totalRecords)
					setLoading(false)
				}
			})
			.catch((err) => {
				console.log(err)
			})
	}
	useEffect(() => {
		setPageIndex(1)
	}, [status])

	useEffect(() => {
		getStore()
		getListData()
	}, [user, pageIndex, pageSize, orderCode, externalCode, statusID])

	useEffect(() => {
		const close = (e) => {
			if (calendarRef?.current?.contains(e?.target)) {
				return
			}
			setIsOpenRange(false)
		}

		if (isOpenRange) {
			window.addEventListener('click', close)
		} else {
		}
		return () => window.removeEventListener('click', close)
	}, [isOpenRange])
	const handleSearchOrderCodeChange = ({ target: { value } }) => {
		if (value || value === '') {
			setSearchOrderCode(value)
		} else {
			setSearchOrderCode(null)
		}
	}
	const onOpenChangeAmount = () => {
		setOpenAmount(!openAmount)
	}
	const handleSearchExternalCodeChange = ({ target: { value } }) => {
		if (value || value === '') {
			setSearchExternalCode(value)
		} else {
			setSearchExternalCode(null)
		}
	}
	const getStore = () => {
		profileService
			.getProfileHubs(user?.clientID)
			.then((response) => {
				setStore(response?.hubs)
			})
			.catch(console.log)
	}
	const onChangePageIndex = (page, pageSize) => {
		setPageIndex(page)
		setPageSize(pageSize)
	}
	const rowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			setListOrderCode(selectedRowKeys)
			// console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
		},
		getCheckboxProps: (record) => ({
			disabled: record.name === 'Disabled User',
			// Column configuration not to be checked
			name: record.name,
		}),
	}

	const handleGetData = () => {
		if (moment(timeRange.endDate).diff(moment(timeRange.startDate), 'days') > TIME_ACCEPT_DAYS) {
			setIsValidTime(true)
		} else {
			getStore()
			getListData()
		}
		setOpenAmount(false)
		setOpenDR(false)
	}
	const handleResetFilter = () => {
		setTimeRange({ startDate: moment().startOf('month'), endDate: new Date() })
		setSearchExternalCode(null)
		setSearchOrderCode(null)
		setClientHubID(0)
		setPageIndex(1)
		setType(false)
		setOpenAmount(false)
		setOpenDR(false)
		setIsReset(!isReset)
	}
	useEffect(() => {
		getStore()
		getListData()
	}, [isReset])

	return (
		<div className="site-card-border-less-wrapper" style={{ width: '100%' }}>
			<Card
				// title={title1}
				bordered={false}
			>
				<Row gutter={[16, 16]}>
					<Col xs={24} sm={24} md={24} lg={6} xl={6}>
						<h2>Ảnh xác nhận phát đơn hàng</h2>
					</Col>
					<Col xs={24} sm={24} md={24} lg={4} xl={4}>
						<div>
							<Input
								placeholder="Tìm kiếm MĐH 247Express"
								style={{
									backgroundImage: 'url("/icons/Search.png")',
									backgroundPosition: '5% 50%',
									backgroundRepeat: 'no-repeat',
									backgroundSize: 15,
									padding: '10px 30px',
								}}
								value={searchOrderCode}
								onChange={handleSearchOrderCodeChange}
								allowClear
							/>
						</div>
					</Col>
					<Col xs={24} sm={24} md={24} lg={4} xl={4}>
						<div>
							<Input
								placeholder="Tìm kiếm MĐH KH"
								style={{
									backgroundImage: 'url("/icons/Search.png")',
									backgroundPosition: '5% 50%',
									backgroundRepeat: 'no-repeat',
									backgroundSize: 15,
									padding: '10px 30px',
								}}
								allowClear
								value={searchExternalCode}
								onChange={handleSearchExternalCodeChange}
							/>
						</div>
					</Col>
					<Col xs={24} sm={24} md={24} lg={3} xl={3}>
						<div className="fee__dropdown-filter-item trigger">
							<Select
								placeholder="Trạng thái"
								style={{ width: '100%' }}
								onChange={(e) => {
									setPageIndex(1)
									setStatusID(e)
								}}
							>
								<Select.Option value={''}>Tất cả</Select.Option>
								<Select.Option value={'16'}>Chờ xử lý</Select.Option>
								<Select.Option value={'25'}>Đang đi phát</Select.Option>
								<Select.Option value={'30'}>Phát thành công</Select.Option>
							</Select>
						</div>
					</Col>
					<Col xs={24} sm={24} md={24} lg={3} xl={3}>
						<div className="fee__dropdown-filter-item trigger">
							<Dropdown
								trigger={'click'}
								onOpenChange={() => setOpenDR(!openDR)}
								overlay={
									<DateFilterBlockV3
										defaultValue={timeRange}
										value={{
											fromDate: timeRange.startDate,
											toDate: timeRange.endDate,
										}}
										onChange={handleTimeRangeChange}
										handleGetData={handleGetData}
										handleResetFilter={handleResetFilter}
									/>
								}
								open={openDR}
							>
								<div className="fee__filter-item">
									<span style={{ fontSize: 14 }}>Thời gian</span>
									<DownOutlined />
								</div>
							</Dropdown>
						</div>
					</Col>

					<Col xs={10} sm={10} md={10} lg={2} xl={2}>
						<DropdownFilter
							handleGetData={handleGetData}
							handleResetFilter={handleResetFilter}
							onOpenChange={onOpenChangeAmount}
							open={openAmount}
						>
							<div style={{ backgroundColor: '#ffffff', borderRadius: 8 }}>
								<Checkbox checked={type} onChange={(e) => setType(e.target.checked)}>
									Vận đơn phát một phần
								</Checkbox>
							</div>
							<div>
								<Select
									placeholder="Chi nhánh/ Cửa hàng"
									style={{ width: '100%' }}
									value={clientHubID}
									onChange={(e) => setClientHubID(e)}
								>
									<Option value={0}>Tất cả</Option>
									{store?.map((item) => (
										<Option value={item?.clientHubID} key={item?.clientHubID}>
											{item?.contactName}
										</Option>
									))}
								</Select>
							</div>
						</DropdownFilter>
					</Col>
					<Col xs={14} sm={14} md={14} lg={2} xl={2}>
						<Button
							type="primary"
							style={{ height: 44, fontSize: 16 }}
							onClick={openModalExportImage}
						>
							Tải ảnh xuống
						</Button>
					</Col>
				</Row>
				<Table
					rowKey={'orderCode'}
					rowSelection={{
						type: 'checkbox',
						...rowSelection,
					}}
					columns={columns}
					dataSource={dataSource}
					size="small"
					scroll={{ x: 1000, scrollToFirstRowOnChange: true }}
					loading={loading}
					pagination={false}
					footer={() => (
						<Row gutter={[0, 16]}>
							<Col span={12} style={{ margin: 'auto' }}>
								<span>
									Hiển thị từ {total == 0 ? 0 : (pageIndex - 1) * pageSize + 1} đến{' '}
									{pageIndex * pageSize > total ? total : pageIndex * pageSize} trong {total} kết
									quả
								</span>
							</Col>
							<Col span={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
								<Pagination
									defaultCurrent={1}
									total={total}
									className="pager_class"
									pageSizeOptions={['10', '20', '30', '40', '50', '100']}
									current={pageIndex}
									showSizeChanger={true}
									onChange={(page, pageSize) => onChangePageIndex(page, pageSize)}
								/>
							</Col>
						</Row>
					)}
				/>
				<NotifyPopup
					isVisible={isVisiblePopup}
					setIsVisiblePopup={setIsVisiblePopup}
					message={messageNoti}
					srcImage={imageNoti}
					handleCancel={() => setIsVisiblePopup(false)}
				></NotifyPopup>
				<NotifyPopup
					isVisible={isValidTime}
					srcImage="/images/fail-noti.png"
					message="Ngày lọc cách nhau không quá 31 ngày."
					handleCancel={() => setIsValidTime(false)}
				></NotifyPopup>
			</Card>
			<ExportImage
				open={visibleExportImage}
				onClose={closeModalExportImage}
				exportFn={handleDownloadImages}
				loadingExport={loadingExport}
			/>
		</div>
	)
}

export default TableImageConfirm
